import React from 'react';

import clsx from 'clsx';

import { MailIcon } from 'components/Icons';

import styles from './MailTo.module.scss';

interface MailToProps {
  subject?: string;
  email?: string;
  body?: string;
  linkClassName?: string;
  iconClassName?: string;
}

const MailTo = ({ subject = '', email, body, linkClassName, iconClassName }: MailToProps) => {
  return (
    <>
      <MailIcon className={clsx(styles.image, iconClassName)} />
      <a
        className={clsx(styles.link, linkClassName)}
        href={`mailto:${email}?subject=${encodeURIComponent(subject) || ''}&body=${
          encodeURIComponent(body ?? '') || ''
        }`}
      >
        {email}
      </a>
    </>
  );
};

export default MailTo;
